import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "../../../Member/Navbar/Navbar";
import "./profile.css";
import ServiceAdmin from "../Services/ServiceAdmin";

import checkAuth from "../../../Login/Services/check-auth";
import { Container, Row, Col, Modal, Form, Button } from "react-bootstrap";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import "./profile.css";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import RemoveIcon from "@material-ui/icons/Remove";
import AddIcon from "@material-ui/icons/Add";
import Icon from "@material-ui/core/Icon";
import { v4 as uuidv4 } from "uuid";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import { makeStyles } from "@material-ui/core/styles";

function EditeProfile() {
  const currnetUser = JSON.parse(sessionStorage.getItem("user"));
  //// Edit  Profile
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }
  const profSante =
    JSON.parse(sessionStorage.getItem("profSante")) &&
    JSON.parse(sessionStorage.getItem("profSante"));
  const idUser =
    JSON.parse(sessionStorage.getItem("user")) &&
    JSON.parse(sessionStorage.getItem("user")).id;
  // get data from profile

  //
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const HandelClick = () => {
    setMessage("fadili");
    setSeverity("warning");
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  //
  const [profileInfos, setProfileInfos] = useState();
  const [details, setDetails] = useState();
  const healthPro =
    JSON.parse(sessionStorage.getItem("healthId")) &&
    JSON.parse(sessionStorage.getItem("healthId")).id;
  useEffect(() => {
    getprofileInfo();
  }, [idUser]);
  //
  const getprofileInfo = () => {
    ServiceAdmin.getprofiledetails(healthPro).then((res) => {
      if (res.data) {
        setProfileInfos(res.data);
        setDetails(JSON.parse(res.data.details));

        setPresentation(JSON.parse(res.data.details).presentation);
        setNsecretariat(JSON.parse(res.data.details).secretariat);
        setDiplomes(
          JSON.parse(res.data.details) &&
            JSON.parse(res.data.details).diplomes.length > 0
            ? JSON.parse(res.data.details).diplomes
            : [{}]
        );
        setExperiences(
          JSON.parse(res.data.details) &&
            JSON.parse(res.data.details).experiences
            ? JSON.parse(res.data.details).experiences
            : [{}]
        );
        setLuMaTime1(
          JSON.parse(res.data.details).horaires &&
            JSON.parse(res.data.details).horaires.lundi.matin.time1
        );
        setLuMaTime2(
          JSON.parse(res.data.details).horaires &&
            JSON.parse(res.data.details).horaires.lundi.matin.time2
        );
        setLuSoiTime1(
          JSON.parse(res.data.details).horaires &&
            JSON.parse(res.data.details).horaires.lundi.soir.time1
        );
        setLuSoiTime2(
          JSON.parse(res.data.details).horaires &&
            JSON.parse(res.data.details).horaires.lundi.soir.time2
        );
        setMaMaTime1(
          JSON.parse(res.data.details).horaires &&
            JSON.parse(res.data.details).horaires.mardi.matin.time1
        );
        setMaMaTime2(
          JSON.parse(res.data.details).horaires &&
            JSON.parse(res.data.details).horaires.mardi.matin.time2
        );
        setMaSoiTime1(
          JSON.parse(res.data.details).horaires &&
            JSON.parse(res.data.details).horaires.mardi.soir.time1
        );
        setMaSoiTime2(
          JSON.parse(res.data.details).horaires &&
            JSON.parse(res.data.details).horaires.mardi.soir.time2
        );
        setMeMaTime1(
          JSON.parse(res.data.details).horaires &&
            JSON.parse(res.data.details).horaires.mecredi.matin.time1
        );
        setMeMaTime2(
          JSON.parse(res.data.details).horaires &&
            JSON.parse(res.data.details).horaires.mecredi.matin.time2
        );
        setMeSoiTime1(
          JSON.parse(res.data.details).horaires &&
            JSON.parse(res.data.details).horaires.mecredi.soir.time1
        );
        setMeSoiTime2(
          JSON.parse(res.data.details).horaires &&
            JSON.parse(res.data.details).horaires.mecredi.soir.time2
        );
        setJeMaTime1(
          JSON.parse(res.data.details).horaires &&
            JSON.parse(res.data.details).horaires.jeudi.matin.time1
        );
        setJeMaTime2(
          JSON.parse(res.data.details).horaires &&
            JSON.parse(res.data.details).horaires.jeudi.matin.time2
        );
        setJeSoiTime1(
          JSON.parse(res.data.details).horaires &&
            JSON.parse(res.data.details).horaires.jeudi.soir.time1
        );
        setJeSoiTime2(
          JSON.parse(res.data.details).horaires &&
            JSON.parse(res.data.details).horaires.jeudi.soir.time2
        );
        setVeMaTime1(
          JSON.parse(res.data.details).horaires &&
            JSON.parse(res.data.details).horaires.vendredi.matin.time1
        );
        setVeMaTime2(
          JSON.parse(res.data.details).horaires &&
            JSON.parse(res.data.details).horaires.vendredi.matin.time2
        );
        setVeSoiTime1(
          JSON.parse(res.data.details).horaires &&
            JSON.parse(res.data.details).horaires.vendredi.soir.time1
        );
        setVeSoiTime2(
          JSON.parse(res.data.details).horaires &&
            JSON.parse(res.data.details).horaires.vendredi.soir.time2
        );
        setSaMaTime1(
          JSON.parse(res.data.details).horaires &&
            JSON.parse(res.data.details).horaires.Samedi.matin.time1
        );
        setSaMaTime2(
          JSON.parse(res.data.details).horaires &&
            JSON.parse(res.data.details).horaires.Samedi.matin.time2
        );
        setSaSoiTime1(
          JSON.parse(res.data.details).horaires &&
            JSON.parse(res.data.details).horaires.Samedi.soir.time1
        );
        setSaSoiTime2(
          JSON.parse(res.data.details).horaires &&
            JSON.parse(res.data.details).horaires.Samedi.soir.time2
        );
        setFacebook(
          JSON.parse(res.data.details).sociaux &&
            JSON.parse(res.data.details).sociaux.facebook
        );
        setInstagram(
          JSON.parse(res.data.details).sociaux &&
            JSON.parse(res.data.details).sociaux.instagram
        );
        setLinkdin(
          JSON.parse(res.data.details).sociaux &&
            JSON.parse(res.data.details).sociaux.linkedin
        );
        sessionStorage.setItem(
          "dataCabinet",
          JSON.stringify(res.data.laboratory ? res.data.laboratory : {})
        );
      }
    });
  };

  //add details profile
  const addDetailsProfile = () => {
    ServiceAdmin.updateprofil(idUser, JSON.stringify(dataProfile)).then(
      (res) => {
        window.location.reload();
        window.location.replace("/profile");
      }
    );
  };

  // useEffect(() => {
  //   setPresentation(details && details.presentation);
  //   setNsecretariat(details && details.secretariat);
  //   setDiplomes(
  //     details && details.diplomes.length > 0 ? details.diplomes : [{}]
  //   );
  //   setExperiences(details && details.experiences ? details.experiences : [{}]);
  // });

  //   Edit Profile
  const [presentation, setPresentation] = useState("");
  // const [dateDip, setDateDip] = useState("");
  const [diplomes, setDiplomes] = useState([{}]);

  const [experiences, setExperiences] = useState([{}]);

  //
  // const cv = JSON.parse(sessionStorage.getItem("profSante"));
  //
  // useEffect(() => {
  //   // GetDataProfile();
  //   setData(JSON.parse(sessionStorage.getItem("profSante")));
  // });

  // const GetDataProfile = () => {

  //   if (data) {
  //     setPresentation(data.presentation);
  //     // setDiplomes(cv.diplomes);
  //     // setExperiences(cv.experiences);
  //   }
  // };
  /////////////////////////////////////////////////////////////////////////////////////
  //Lundi
  const [LuMaTime1, setLuMaTime1] = useState("");
  const [LuMaTime2, setLuMaTime2] = useState("");
  const [LuSoiTime1, setLuSoiTime1] = useState("");
  const [LuSoiTime2, setLuSoiTime2] = useState("");
  // mardi
  const [MaMaTime1, setMaMaTime1] = useState("");
  const [MaMaTime2, setMaMaTime2] = useState("");
  const [MaSoiTime1, setMaSoiTime1] = useState("");
  const [MaSoiTime2, setMaSoiTime2] = useState("");
  // mecredi
  const [MeMaTime1, setMeMaTime1] = useState("");
  const [MeMaTime2, setMeMaTime2] = useState("");
  const [MeSoiTime1, setMeSoiTime1] = useState("");
  const [MeSoiTime2, setMeSoiTime2] = useState("");
  // Jeudi
  const [JeMaTime1, setJeMaTime1] = useState("");
  const [JeMaTime2, setJeMaTime2] = useState("");
  const [JeSoiTime1, setJeSoiTime1] = useState("");
  const [JeSoiTime2, setJeSoiTime2] = useState("");
  // vendredi
  const [VeMaTime1, setVeMaTime1] = useState("");
  const [VeMaTime2, setVeMaTime2] = useState("");
  const [VeSoiTime1, setVeSoiTime1] = useState("");
  const [VeSoiTime2, setVeSoiTime2] = useState("");
  // Samedi
  const [SaMaTime1, setSaMaTime1] = useState("");
  const [SaMaTime2, setSaMaTime2] = useState("");
  const [SaSoiTime1, setSaSoiTime1] = useState("");
  const [SaSoiTime2, setSaSoiTime2] = useState("");
  //////////////////////////////////////////////////////////////////////////
  const [numSecretariat, setNsecretariat] = useState("");
  const [facebook, setFacebook] = useState("");
  const [instagram, setInstagram] = useState("");
  const [Linkdin, setLinkdin] = useState("");

  // Experiences
  const handleChangeInput = (id, event) => {
    const newExperiences = experiences.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setExperiences(newExperiences);
  };

  const handleAddFields = () => {
    setExperiences([
      ...experiences,
      { id: uuidv4(), dateD: "", dateF: "", discription: "" },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...experiences];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setExperiences(values);
  };

  // Diplomes
  const handleChangeInputDip = (id, event) => {
    const newDiplome = diplomes.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
      }
      return i;
    });
    setDiplomes(newDiplome);
  };

  const handleAddFieldsDip = () => {
    setDiplomes([
      ...diplomes,
      { id: uuidv4(), dateDiplome: "", discription: "" },
    ]);
  };

  const handleRemoveFieldsDip = (id) => {
    const values = [...diplomes];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setDiplomes(values);
  };

  // data experiences
  const dataProfile = {
    presentation: presentation,
    diplomes: diplomes,
    experiences: experiences,
    horaires: {
      lundi: {
        matin: { time1: LuMaTime1, time2: LuMaTime2 },
        soir: { time1: LuSoiTime1, time2: LuSoiTime2 },
      },
      mardi: {
        matin: { time1: MaMaTime1, time2: MaMaTime2 },
        soir: { time1: MaSoiTime1, time2: MaSoiTime2 },
      },
      mecredi: {
        matin: { time1: MeMaTime1, time2: MeMaTime2 },
        soir: { time1: MeSoiTime1, time2: MeSoiTime2 },
      },
      jeudi: {
        matin: { time1: JeMaTime1, time2: JeMaTime2 },
        soir: { time1: JeSoiTime1, time2: JeSoiTime2 },
      },
      vendredi: {
        matin: { time1: VeMaTime1, time2: VeMaTime2 },
        soir: { time1: VeSoiTime1, time2: VeSoiTime2 },
      },
      Samedi: {
        matin: { time1: SaMaTime1, time2: SaMaTime2 },
        soir: { time1: SaSoiTime1, time2: SaSoiTime2 },
      },
    },
    secretariat: numSecretariat,
    sociaux: {
      facebook: facebook,
      linkedin: Linkdin,
      instagram: instagram,
    },
  };

  return (
    <>
      <Snackbar open={open} autoHideDuration={40000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={severity}>
          {message}
        </Alert>
      </Snackbar>
      <Navbar />

      <div
        className="container bootstrap snippets bootdeys"
        style={{ marginTop: "20px" }}
      >
        <div className="row" id="user-profile">
          <div className="col-lg-3 col-md-4 col-sm-4">
            <div className="main-box clearfix">
              <h2>
                {profSante && `${profSante.firstName} ${profSante.lastName} `}
              </h2>
              {/* <div className="profile-status">
                <i className="fa fa-check-circle"></i> Online
              </div> */}
              <img
                src="https://bootdey.com/img/Content/avatar/avatar1.png"
                alt=""
                width="100%"
                className="profile-img img-responsive center-block"
              />
              <div className="profile-stars">
                <div className="profile-user-details clearfix">
                  <div className="profile-user-details-label">
                    <b>Address:</b>
                  </div>
                  <div className="profile-user-details-value">
                    {profSante && profSante.laboratory
                      ? profSante.laboratory.address
                      : "-"}
                    <br />
                    {profSante && profSante.city ? profSante.city.name : "-"}
                  </div>
                </div>
                <div className="profile-user-details clearfix">
                  <div className="profile-user-details-label">
                    <b>Email:</b>
                  </div>
                  <div className="profile-user-details-value">
                    {profSante && profSante.email}
                  </div>
                </div>
                <div className="profile-user-details clearfix">
                  <div className="profile-user-details-label">
                    <b>Phone:</b>
                  </div>
                  <div className="profile-user-details-value">
                    {profSante && profSante.tel}
                  </div>
                </div>
              </div>
              {details && (
                <div className="profile-details">
                  <ul className="fa-ul">
                    <li>
                      <i className="fa-li fa fa-linkedin-square"></i>
                      <a
                        href={details.sociaux && details.sociaux.linkedin}
                        target="_blank"
                      >
                        Linkdin
                      </a>
                    </li>
                    <li>
                      <i className="fa-li fa fa-facebook-square"></i>
                      <a
                        href={details.sociaux && details.sociaux.facebook}
                        target="_blank"
                      >
                        Facebook{" "}
                      </a>
                    </li>
                    <li>
                      <i className="fa-li fa fa-instagram"></i>
                      <a
                        href={details.sociaux && details.sociaux.instagram}
                        target="_blank"
                      >
                        Instagram
                      </a>
                    </li>
                  </ul>
                </div>
              )}

              {checkAuth && currnetUser && currnetUser.role === "ADMIN" ? (
                ""
              ) : checkAuth && currnetUser && currnetUser.role === "USER" ? (
                ""
              ) : (
                <div className="profile-message-btn center-block text-center">
                  <Link
                    to={
                      currnetUser
                        ? profileInfos && profileInfos.speciality
                          ? "/pageanalyse"
                          : "/home"
                        : "/login"
                    }
                  >
                    <Button
                      className="m-auto "
                      variant="primary"
                      style={{ fontSize: "smaller", color: "white" }}
                      onClick={() => {
                        // sessionStorage.setItem(
                        //   "Type",
                        //   JSON.stringify({
                        //     type: "No Covid",
                        //   })
                        // );
                        profileInfos &&
                          sessionStorage.setItem(
                            "lieux",
                            JSON.stringify(
                              profileInfos.laboratory
                                ? profileInfos.laboratory
                                : {}
                            )
                          );
                      }}
                    >
                      <i
                        className="fas fa-calendar-check mr-2"
                        style={{
                          color: "white",
                          backgroundColor: "#0596de",
                        }}
                      ></i>
                      PRENDRE RENDEZ-VOUS
                    </Button>
                  </Link>
                </div>
              )}
            </div>
          </div>

          <div className="col-lg-9 col-md-8 col-sm-8">
            <div className="main-box clearfix">
              {currnetUser && currnetUser.role == "ADMIN" && (
                <div className="profile-header">
                  <Link to="/profile">
                    <Button className="btn ml-2 mb-2 btn-info edit-profile">
                      <AccountBoxIcon /> Profile
                    </Button>
                  </Link>
                </div>
              )}
              {currnetUser && currnetUser.role == "USER" && (
                <div className="profile-header">
                  <Link to="/profile">
                    <Button className="btn ml-2 mb-2 btn-info edit-profile">
                      <AccountBoxIcon /> Profile
                    </Button>
                  </Link>
                </div>
              )}
              <div className="profile-header">
                <h6
                  style={{
                    marginTop: "27px",
                    marginBottom: "18px",
                    fontSize: "x-large",
                  }}
                >
                  Modifier Profile :
                </h6>

                <Container>
                  <Row>
                    <Col lg={12}>
                      <div className="profile-header">
                        <h3>
                          <span>Présentation :</span>
                        </h3>
                        <Form.Control
                          className="mb-2"
                          as="textarea"
                          defaultValue={presentation}
                          onChange={(e) => setPresentation(e.target.value)}
                          rows={3}
                        />
                      </div>
                    </Col>
                    <Col lg={12}>
                      <div className="profile-header">
                        <h3>
                          <span>Diplômes et Fonctions :</span>
                        </h3>
                        {diplomes.map((diplome) => (
                          <Row key={diplome.id}>
                            <Col lg={3}>
                              <Form.Control
                                className="mb-2"
                                type="text"
                                name="date"
                                placeholder="date"
                                defaultValue={diplome.date}
                                onChange={(event) =>
                                  handleChangeInputDip(diplome.id, event)
                                }
                              />
                            </Col>
                            <Col lg={6}>
                              <Form.Control
                                className="mb-2"
                                name="discription"
                                type="text"
                                placeholder="text"
                                defaultValue={diplome.discription}
                                onChange={(event) =>
                                  handleChangeInputDip(diplome.id, event)
                                }
                              />
                            </Col>
                            <Col lg={3}>
                              <Button
                                className="mr-1 mb-2"
                                variant="danger"
                                disabled={diplomes.length === 1}
                                onClick={() =>
                                  handleRemoveFieldsDip(diplome.id)
                                }
                              >
                                <RemoveIcon />
                              </Button>
                              <Button
                                className="mr-1 mb-2"
                                onClick={() => handleAddFieldsDip()}
                              >
                                <AddIcon />
                              </Button>
                            </Col>
                          </Row>
                        ))}
                      </div>
                    </Col>
                    <Col lg={12}>
                      <div className="profile-header">
                        <h3>
                          <span>Expériences :</span>
                        </h3>
                        {experiences.map((experience) => (
                          <Row key={experience.id}>
                            <Col lg={2}>
                              <Form.Control
                                className="mr-1 mb-2"
                                type="text"
                                name="dateD"
                                placeholder="dateD"
                                defaultValue={experience.dateD}
                                onChange={(event) =>
                                  handleChangeInput(experience.id, event)
                                }
                              />
                            </Col>
                            <Col lg={2}>
                              <Form.Control
                                className="mr-1 mb-2"
                                type="text"
                                name="dateF"
                                placeholder="dateF"
                                defaultValue={experience.dateF}
                                onChange={(event) =>
                                  handleChangeInput(experience.id, event)
                                }
                              />
                            </Col>
                            <Col lg={5}>
                              <Form.Control
                                className="mr-1 mb-2"
                                type="text"
                                name="discription"
                                placeholder="discription"
                                defaultValue={experience.discription}
                                onChange={(event) =>
                                  handleChangeInput(experience.id, event)
                                }
                              />
                            </Col>
                            <Col lg={3}>
                              <Button
                                className="mr-1 mb-2"
                                variant="danger"
                                disabled={experiences.length === 1}
                                onClick={() =>
                                  handleRemoveFields(experience.id)
                                }
                              >
                                <RemoveIcon />
                              </Button>
                              <Button
                                className="mr-1 mb-2"
                                onClick={() => handleAddFields()}
                              >
                                <AddIcon />
                              </Button>
                            </Col>
                          </Row>
                        ))}
                      </div>
                    </Col>
                    <Col lg={12}>
                      <div className="profile-header">
                        <h3>
                          <span>Horaires et contacts :</span>
                        </h3>
                        <strong>Ouverture du secrétariat</strong>
                        <Row>
                          <table
                            className="tableProfile"
                            style={{ width: "100%", textAlign: "center" }}
                          >
                            <tr>
                              <th></th>
                              <th>Matin</th>
                              <th>Soir</th>
                            </tr>
                            <tr>
                              <td>Lundi</td>
                              <td>
                                <Row>
                                  <Col lg={6}>
                                    <Form.Control
                                      className="mb-2"
                                      type="text"
                                      placeholder="time"
                                      value={LuMaTime1}
                                      onChange={(e) =>
                                        setLuMaTime1(e.target.value)
                                      }
                                    />
                                  </Col>
                                  <Col lg={6}>
                                    <Form.Control
                                      type="text"
                                      placeholder="time"
                                      value={LuMaTime2}
                                      onChange={(e) =>
                                        setLuMaTime2(e.target.value)
                                      }
                                    />
                                  </Col>
                                </Row>
                              </td>
                              <td>
                                <Row>
                                  <Col lg={6}>
                                    <Form.Control
                                      type="text"
                                      className="mb-2"
                                      placeholder="time"
                                      value={LuSoiTime1}
                                      onChange={(e) =>
                                        setLuSoiTime1(e.target.value)
                                      }
                                    />
                                  </Col>
                                  <Col lg={6}>
                                    <Form.Control
                                      type="text"
                                      placeholder="time"
                                      value={LuSoiTime2}
                                      onChange={(e) =>
                                        setLuSoiTime2(e.target.value)
                                      }
                                    />
                                  </Col>
                                </Row>
                              </td>
                            </tr>
                            <tr>
                              <td>Mardi</td>
                              <td>
                                <Row>
                                  <Col lg={6}>
                                    <Form.Control
                                      className="mb-2"
                                      type="text"
                                      placeholder="time"
                                      value={MaMaTime1}
                                      onChange={(e) =>
                                        setMaMaTime1(e.target.value)
                                      }
                                    />
                                  </Col>
                                  <Col lg={6}>
                                    <Form.Control
                                      type="text"
                                      placeholder="time"
                                      value={MaMaTime2}
                                      onChange={(e) =>
                                        setMaMaTime2(e.target.value)
                                      }
                                    />
                                  </Col>
                                </Row>
                              </td>
                              <td>
                                <Row>
                                  <Col lg={6}>
                                    <Form.Control
                                      className="mb-2"
                                      type="text"
                                      placeholder="time"
                                      value={MaSoiTime1}
                                      onChange={(e) =>
                                        setMaSoiTime1(e.target.value)
                                      }
                                    />
                                  </Col>
                                  <Col lg={6}>
                                    <Form.Control
                                      type="text"
                                      placeholder="time"
                                      value={MaSoiTime2}
                                      onChange={(e) =>
                                        setMaSoiTime2(e.target.value)
                                      }
                                    />
                                  </Col>
                                </Row>
                              </td>
                            </tr>
                            <tr>
                              <td>Mercredi</td>
                              <td>
                                <Row>
                                  <Col lg={6}>
                                    <Form.Control
                                      className="mb-2"
                                      type="text"
                                      placeholder="time"
                                      value={MeMaTime1}
                                      onChange={(e) =>
                                        setMeMaTime1(e.target.value)
                                      }
                                    />
                                  </Col>
                                  <Col lg={6}>
                                    <Form.Control
                                      type="text"
                                      placeholder="time"
                                      value={MeMaTime2}
                                      onChange={(e) =>
                                        setMeMaTime2(e.target.value)
                                      }
                                    />
                                  </Col>
                                </Row>
                              </td>
                              <td>
                                <Row>
                                  <Col lg={6}>
                                    <Form.Control
                                      className="mb-2"
                                      type="text"
                                      placeholder="time"
                                      value={MeSoiTime1}
                                      onChange={(e) =>
                                        setMeSoiTime1(e.target.value)
                                      }
                                    />
                                  </Col>
                                  <Col lg={6}>
                                    <Form.Control
                                      type="text"
                                      placeholder="time"
                                      value={MeSoiTime2}
                                      onChange={(e) =>
                                        setMeSoiTime2(e.target.value)
                                      }
                                    />
                                  </Col>
                                </Row>
                              </td>
                            </tr>
                            <tr>
                              <td>Jeudi</td>
                              <td>
                                <Row>
                                  <Col lg={6}>
                                    <Form.Control
                                      className="mb-2"
                                      type="text"
                                      placeholder="time"
                                      value={JeMaTime1}
                                      onChange={(e) =>
                                        setJeMaTime1(e.target.value)
                                      }
                                    />
                                  </Col>
                                  <Col lg={6}>
                                    <Form.Control
                                      type="text"
                                      placeholder="time"
                                      value={JeMaTime2}
                                      onChange={(e) =>
                                        setJeMaTime2(e.target.value)
                                      }
                                    />
                                  </Col>
                                </Row>
                              </td>
                              <td>
                                <Row>
                                  <Col lg={6}>
                                    <Form.Control
                                      className="mb-2"
                                      type="text"
                                      placeholder="time"
                                      value={JeSoiTime1}
                                      onChange={(e) =>
                                        setJeSoiTime1(e.target.value)
                                      }
                                    />
                                  </Col>
                                  <Col lg={6}>
                                    <Form.Control
                                      type="text"
                                      placeholder="time"
                                      value={JeSoiTime2}
                                      onChange={(e) =>
                                        setJeSoiTime2(e.target.value)
                                      }
                                    />
                                  </Col>
                                </Row>
                              </td>
                            </tr>
                            <tr>
                              <td>Vendredi</td>
                              <td>
                                <Row>
                                  <Col lg={6}>
                                    <Form.Control
                                      className="mb-2"
                                      type="text"
                                      placeholder="time"
                                      value={VeMaTime1}
                                      onChange={(e) =>
                                        setVeMaTime1(e.target.value)
                                      }
                                    />
                                  </Col>
                                  <Col lg={6}>
                                    <Form.Control
                                      type="text"
                                      placeholder="time"
                                      value={VeMaTime2}
                                      onChange={(e) =>
                                        setVeMaTime2(e.target.value)
                                      }
                                    />
                                  </Col>
                                </Row>
                              </td>
                              <td>
                                <Row>
                                  <Col lg={6}>
                                    <Form.Control
                                      className="mb-2"
                                      type="text"
                                      placeholder="time"
                                      value={VeSoiTime1}
                                      onChange={(e) =>
                                        setVeSoiTime1(e.target.value)
                                      }
                                    />
                                  </Col>
                                  <Col lg={6}>
                                    <Form.Control
                                      type="text"
                                      placeholder="time"
                                      value={VeSoiTime2}
                                      onChange={(e) =>
                                        setVeSoiTime2(e.target.value)
                                      }
                                    />
                                  </Col>
                                </Row>
                              </td>
                            </tr>
                            <tr>
                              <td>Samedi</td>
                              <td>
                                <Row>
                                  <Col lg={6}>
                                    <Form.Control
                                      className="mb-2"
                                      type="text"
                                      placeholder="time"
                                      value={SaMaTime1}
                                      onChange={(e) =>
                                        setSaMaTime1(e.target.value)
                                      }
                                    />
                                  </Col>
                                  <Col lg={6}>
                                    <Form.Control
                                      type="text"
                                      placeholder="time"
                                      value={SaMaTime2}
                                      onChange={(e) =>
                                        setSaMaTime2(e.target.value)
                                      }
                                    />
                                  </Col>
                                </Row>
                              </td>
                              <td>
                                <Row>
                                  <Col lg={6}>
                                    <Form.Control
                                      className="mb-2"
                                      type="text"
                                      placeholder="time"
                                      value={SaSoiTime1}
                                      onChange={(e) =>
                                        setSaSoiTime1(e.target.value)
                                      }
                                    />
                                  </Col>
                                  <Col lg={6}>
                                    <Form.Control
                                      type="text"
                                      placeholder="time"
                                      value={SaSoiTime2}
                                      onChange={(e) =>
                                        setSaSoiTime2(e.target.value)
                                      }
                                    />
                                  </Col>
                                </Row>
                              </td>
                            </tr>
                          </table>
                        </Row>
                        <Row>
                          <Col lg={4}>
                            <strong>Contact du secrétariat</strong>
                          </Col>
                          <Col lg={6}>
                            <Form.Control
                              type="text"
                              placeholder="text"
                              defaultValue={numSecretariat}
                              onChange={(e) => setNsecretariat(e.target.value)}
                            />
                          </Col>
                        </Row>
                      </div>
                    </Col>
                    <Col lg={12}>
                      <div className="profile-header">
                        <h3>
                          <span>Emédias Sociaux :</span>
                        </h3>
                        <table
                          className="tableProfile"
                          style={{ width: "100%", textAlign: "center" }}
                        >
                          <tr>
                            <th>Facebook</th>
                            <th>Linkdin</th>
                            <th>Instagram</th>
                          </tr>
                          <tr>
                            <Col sm={12}>
                              <td>
                                <Form.Control
                                  type="text"
                                  placeholder="Url Facebook"
                                  value={facebook}
                                  onChange={(e) => setFacebook(e.target.value)}
                                />
                              </td>
                            </Col>

                            <td>
                              <Form.Control
                                type="text"
                                placeholder="Url Linkdin"
                                value={Linkdin}
                                onChange={(e) => setLinkdin(e.target.value)}
                              />
                            </td>
                            <td>
                              <Form.Control
                                type="text"
                                placeholder="Url Instagram"
                                value={instagram}
                                onChange={(e) => setInstagram(e.target.value)}
                              />
                            </td>
                          </tr>
                        </table>
                      </div>
                    </Col>
                  </Row>
                </Container>

                <Button
                  className="btn"
                  variant="success"
                  onClick={() => addDetailsProfile()}
                  style={{
                    float: "right",
                    width: "160px",
                  }}
                >
                  Save Profile
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditeProfile;
